module.exports = __webpack_public_path__ + "static/img/110117.ef2f956f.png";